import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router'
import {
  AppstoreOutlined,
  CalendarOutlined,
  DotChartOutlined,
  ExclamationOutlined,
  FullscreenExitOutlined,
  GiftOutlined,
  HomeOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PlusCircleOutlined,
  ProfileOutlined,
  ShopOutlined,
  TeamOutlined,
  UserOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import { Button, Layout, Menu } from 'antd'
import { useSelector } from 'react-redux'

const { Header, Sider, Content } = Layout

function Home({ children }) {
  const navigate = useNavigate()
  const location = useLocation()
  const auth = useSelector((state) => state.auth)

  const [collapsed, setCollapsed] = useState(false)
  const [menuKey, setMenuKey] = useState(location?.pathname?.substring(1))

  const onClick = (e) => {
    navigate(`/${e.key}`)
    setMenuKey(e.key)
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider trigger={null} collapsible collapsed={collapsed} breakpoint="md" collapsedWidth="0">
        <Menu
          onClick={onClick}
          theme="dark"
          mode="inline"
          // defaultSelectedKeys={['home']}
          selectedKeys={[menuKey]}
          items={[
            {
              key: 'home',
              icon: <HomeOutlined />,
              label: 'Home',
            },
            {
              key: 'profile',
              icon: <UserOutlined />,
              label: 'Profile',
            },
            {
              key: 'members',
              icon: <TeamOutlined />,
              label: 'Members',
            },
            {
              key: 'focusAreas',
              icon: <FullscreenExitOutlined />,
              label: 'Focus Areas',
            },
            {
              key: 'metrics',
              icon: <DotChartOutlined />,
              label: 'Metrics',
            },
            {
              key: 'ClubEvents',
              icon: <CalendarOutlined />,
              label: 'Club Events',
            },
            {
              key: 'referrals',
              icon: <GiftOutlined />,
              label: 'Referrals',
            },
            ...(auth.user.type === 'super-admin'
              ? [
                  {
                    key: 'clubs',
                    label: 'Clubs',
                    icon: <ShopOutlined />,
                  },
                  {
                    key: 'activitySuggestions',
                    icon: <PlusCircleOutlined />,
                    label: 'Task Suggestions',
                  },
                  {
                    key: 'reportedCelebrationPosts',
                    icon: <ExclamationOutlined />,
                    label: 'Celebrate Reports',
                  },
                  {
                    key: 'reportedFeedPosts',
                    icon: <ExclamationOutlined />,
                    label: 'Feed Reports',
                  },
                  {
                    key: 'logs',
                    icon: <ProfileOutlined />,
                    label: 'Logs',
                  },
                  {
                    key: 'appInputs',
                    icon: <AppstoreOutlined />,
                    label: 'App Versions',
                  },
                  {
                    key: 'getStarted',
                    icon: <LogoutOutlined />,
                    label: 'Get Started',
                  },
                  {
                    key: 'manageSearch',
                    icon: <SearchOutlined />,
                    label: 'Manage Search',
                  },
                  {
                    key: 'ManageStore',
                    icon: <ShopOutlined />,
                    label: 'Manage Store',
                  },
                ]
              : []),
          ]}
        />
      </Sider>
      <Layout>
        <Header
          style={{
            padding: 0,
            background: 'white',
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          />
        </Header>
        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: 280,
            background: 'white',
            borderRadius: 20,
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  )
}

export default Home
